import { gql } from 'apollo-angular';

export const LIST_OMC_REGISTRATION = gql`
  query ListOmcRegistration($pageableParam: PageableParamInput!) {
    listOmcRegistration(pageableParam: $pageableParam) {
      content {
        active
        brelaExpireDate
        brelaLicenseNumber
        brelaRegDate
        companyName
        name
        ewuraExpireDate
        ewuraLicenseNumber
        ewuraRegDate
        registrationDate
        registrationNumber
        registrationStatus
        registrationType
        traExpireDate
        traLicenseNumber
        traRegDate
        uuid
        company {
          id
          name
          uuid
        }
      }
      first
      hasContent
      hasNext
      hasPrevious
      last
      totalPages
      totalElements
      size
      number
      numberOfElements
    }
  }
`;

export const GET_OMC_CONTRACTS = gql`
  query GetOmcContracts($pageableParam: PageableParamInput!) {
    getOmcContracts(pageableParam: $pageableParam) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        active
        attachableDiscriminator
        bucketName
        contractNumber
        createdAt
        createdBy
        endAt
        otherAttachmentName
        registrationStatus
        registrationType
        startAt
        updatedAt
        updatedBy
        uuid
        workflowDefinitionKey
        workflowInstanceId
        workflowStatus
        omcRegistration {
          uuid
        }
      }
    }
  }
`;

export const OMC_DEMAND_SUBMISSIONS = gql`
  query OmcDemandSubmissions($pageableParam: PageableParamInput!) {
    omcDemandSubmissions(pageableParam: $pageableParam) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        active
        companyId
        companyName
        cycleUuid
        omcUuid
        status
        submittedAt
        submittedBy
        uuid
        locked
        cycle {
          active
          demandMonth
          demandYear
          status
          uuid
        }
        lines {
          active
          cargoIdentifier
          portName
          portUuid
          productName
          productUuid
          totalQty
          uuid
          vesselUuid
          sourcingEntries {
            active
            computedPercent
            quantity
            usageName
            usageUuid
            uuid
            usage {
              active
              isTransit
              usageName
              uuid
            }
          }
        }
      }
      nextPageable {
        pageNumber
        pageSize
      }
      nextOrLastPageable {
        pageNumber
        pageSize
      }
      pageable {
        pageNumber
        pageSize
      }
      previousOrFirstPageable {
        pageNumber
        pageSize
      }
      previousPageable {
        pageNumber
        pageSize
      }
      sort {
        orders {
          direction
          ignoreCase
          nullHandlingHint
          property
        }
      }
    }
  }
`;

export const OMC_DEMAND_BY_UUID = gql`
  query OmcDemandByUuid(
    $uuid: UUID!
    $includeCycle: Boolean = true
    $includeLines: Boolean = true
    $includeConsignees: Boolean = true
    $includeTransitStocks: Boolean = true
    $includeProjections: Boolean = true
    $includeAttachments: Boolean = true
  ) {
    omcDemandByUuid(uuid: $uuid) {
      data {
        active
        companyId
        companyName
        cycleUuid
        omcUuid
        registrationType
        status
        submittedAt
        uuid
        attachments @include(if: $includeAttachments) {
          active
          id
          minioObjectName
          otherAttachmentName
          uuid
          attachable {
            attachableDiscriminator
            bucketName
            id
            otherAttachmentName
            registrationType
            uuid
          }
          attachmentType {
            active
            fileSize
            fileType
            id
            kind
            name
            uuid
          }
        }
        consignees @include(if: $includeConsignees) {
          cargoUuid
          consigneeName
          consigneeUuid
          productName
          productUsageName
          productUsageUuid
          productUuid
          quantity
          transitStatus
          uuid
          cargo {
            active
            port {
              portName
              active
              uuid
            }
            cargoIdentifier
            deliveryEndDate
            deliveryStartDate
            portNames
          }
          attachments {
            minioObjectName
            uuid
            attachable {
              id
              registrationType
              uuid
            }
            attachmentType {
              fileSize
              fileType
              name
              uuid
            }
          }
          consignee {
            companyName
            countryId
            countryName
            email
            phoneNumber
            registrationNumber
            uuid
            directors {
              email
              name
              phoneNumber
              uuid
              consignee {
                uuid
              }
            }
          }
          productUsage {
            isTransit
            usageName
            uuid
          }
        }
        projections @include(if: $includeProjections) {
          periodLabel
          portName
          portUuid
          productName
          productUuid
          projectionMonth
          projectionYear
          totalQty
          uuid
          sourcingEntries {
            computedPercent
            quantity
            usageName
            usageUuid
            uuid
            usage {
              usageName
              isTransit
              uuid
            }
          }
        }
        transitStocks @include(if: $includeTransitStocks) {
          consigneeName
          consigneeProductName
          consigneeUuid
          holdingTerminalName
          holdingTerminalUuid
          importedQuantityM2
          productGrade
          productName
          productUuid
          remainingQuantity
          upliftedQuantity
          uuid
          vesselName
          consignee {
            companyName
            uuid
          }
        }
        lines @include(if: $includeLines) {
          cargoIdentifier
          portName
          portUuid
          productName
          productUuid
          splitComplianceMessage
          splitCompliant
          totalQty
          uuid
          vesselUuid
          preferedCargoUuid
          remarks
          sourcingEntries {
            computedPercent
            quantity
            usageName
            usageUuid
            terminalName
            terminalUuid
            uuid
            usage {
              isTransit
              usageName
              uuid
            }
          }
        }
        cycle @include(if: $includeCycle) {
          active
          cancellationReason
          demandMonth
          demandYear
          pbpaOverrideEnabled
          status
          submissionCloseDateTime
          submissionOpenDateTime
          uuid
          activatedAt
          ports {
            portName
            portUuid
            uuid
            port {
              code
              description
              maxCapacityMt
              portName
              regionName
              regionUuid
              uuid
            }
            vessels {
              cargoIdentifier
              deliveryEndDate
              deliveryStartDate
              splitEnforcementEnabled
              splitEnforcementMode
              uuid
              products {
                active
                productName
                productUuid
                uuid
                product {
                  active
                  minCapacityMt
                  productName
                  uuid
                }
              }
              sourcingSplits {
                percent
                usageName
                usageUuid
                uuid
                usage {
                  usageName
                  uuid
                }
              }
            }
          }
        }
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const OMC_DEMAND_CYCLES = gql`
  query DemandCycles($pageableParam: PageableParamInput!) {
    demandCycles(pageableParam: $pageableParam) {
      first
      hasContent
      hasNext
      hasPrevious
      last
      number
      numberOfElements
      size
      totalElements
      totalPages
      content {
        active
        demandMonth
        demandYear
        status
        uuid
      }
    }
  }
`;

export const ACTIVE_OPEN_DEMAND_CYCLES = gql`
  query ActiveOpenDemandCycles {
    activeOpenDemandCycles {
      data {
        activatedAt
        activatedBy
        active
        demandMonth
        demandYear
        pbpaOverrideEnabled
        status
        submissionCloseDateTime
        submissionOpenDateTime
        uuid
        createdAt
        windowComment
        ports {
          active
          portName
          portUuid
          updatedAt
          updatedBy
          uuid
          port {
            code
            maxCapacityMt
            portName
            regionName
            uuid
          }
          vessels {
            active
            cargoIdentifier
            deliveryEndDate
            deliveryStartDate
            splitEnforcementEnabled
            splitEnforcementMode
            uuid
            products {
              active
              productName
              productUuid
              uuid
              product {
                active
                minCapacityMt
                productName
                uuid
              }
            }
            sourcingSplits {
              active
              percent
              usageName
              usageUuid
              uuid
            }
          }
        }
        closedAt
      }
      code
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const OMC_DEMAND_CYCLE_BY_UUID = gql`
  query DemandCycleByUuid($uuid: UUID) {
    demandCycleByUuid(uuid: $uuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        demandMonth
        demandYear
        status
        submissionCloseDateTime
        submissionOpenDateTime
        uuid
        ports {
          active
          portName
          portUuid
          uuid
          port {
            code
            maxCapacityMt
            portName
            regionName
            uuid
          }
          vessels {
            active
            deliveryEndDate
            deliveryStartDate
            splitEnforcementEnabled
            splitEnforcementMode
            uuid
            cargoIdentifier
            products {
              active
              productName
              productUuid
              uuid
              product {
                active
                minCapacityMt
                productName
                uuid
              }
            }
            sourcingSplits {
              active
              percent
              usageName
              usageUuid
              uuid
            }
          }
        }
      }
    }
  }
`;

export const SAVE_OMC_DRAFT_DEMAND = gql`
  mutation SaveOmcDemandDraft($input: SaveOmcDemandInputInput!) {
    saveOmcDemandDraft(input: $input) {
      code
      data {
        active
        companyId
        companyName
        createdAt
        cycleUuid
        nonComplianceReason
        omcUuid
        status
        uuid
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SUBMIT_OMC_DEMAND = gql`
  mutation SubmitOmcDemand($submissionUuid: UUID!, $isDeclared: Boolean!) {
    submitOmcDemand(submissionUuid: $submissionUuid, isDeclared: $isDeclared) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        attachableDiscriminator
        bucketName
        companyId
        companyName
        cycleUuid
        nonComplianceReason
        omcUuid
        otherAttachmentName
        registrationType
        status
        uuid
        submittedAt
      }
    }
  }
`;

export const CREATE_OMC_TERMINAL_AGREEMENT = gql`
  mutation CreateOmcTerminalAgreement($input: OmcTerminalAgreementReqInput!) {
    createOmcTerminalAgreement(input: $input) {
      code
      data {
        active
        agreementNumber
        agreementStatus
        attachableDiscriminator
        bucketName
        companyName
        discriminator
        endDate
        otherAttachmentName
        registrationType
        remarks
        startDate
        type
        uuid
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SUBMIT_OMC_TERMINAL_AGREEMENT = gql`
  mutation SubmitOmcTerminalAgreement($input: UUID!) {
    submitOmcTerminalAgreement(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        agreementNumber
        agreementStatus
        discriminator
        endDate
        otherAttachmentName
        registrationType
        remarks
        startDate
        type
        uuid
      }
    }
  }
`;

export const UPDATE_OMC_TERMINAL_AGREEMENT = gql`
  mutation UpdateOmcTerminalAgreement($input: OmcTerminalAgreementUpdateReqInput!) {
    updateOmcTerminalAgreement(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        agreementNumber
        agreementStatus
        attachableDiscriminator
        bucketName
        companyName
        discriminator
        endDate
        otherAttachmentName
        registrationType
        remarks
        startDate
        type
        uuid
      }
    }
  }
`;

export const GET_ALL_OMC_TERMINAL_AGREEMENTS = gql`
  query GetOmcTerminalAgreementsByOmc($pageable: PageableParamInput!, $omcUuid: UUID!) {
    getOmcTerminalAgreementsByOmc(pageableParam: $pageable, omcUuid: $omcUuid) {
      content {
        active
        agreementNumber
        agreementStatus
        endDate
        startDate
        remarks
        type
        uuid
        omcRegistration {
          name
          tin
          uuid
          company {
            active
            tin
            uuid
            tinOrTaxpayerNumber
            name
          }
        }
        attachment {
          uuid
          minioObjectName
          otherAttachmentName
          attachmentType {
            uuid
            name
          }
        }
        terminalRegistration {
          referenceNumber
          terminalName
          uuid
          company {
            active
            tin
            uuid
            tinOrTaxpayerNumber
            name
          }
        }
      }
      totalPages
      totalElements
      size
      pageable {
        pageNumber
        pageSize
      }
      number
      numberOfElements
      last
      hasPrevious
      hasNext
      hasContent
      first
    }
  }
`;

export const GET_OMC_TERMINAL_AGREEMENT = gql`
  query GetOmcTerminalAgreement($uuid: UUID) {
    getOmcTerminalAgreement(uuid: $uuid) {
      code
      data {
        active
        agreementNumber
        agreementStatus
        attachableDiscriminator
        bucketName
        companyName
        createdAt
        discriminator
        endDate
        otherAttachmentName
        remarks
        startDate
        type
        uuid
        attachment {
          active
          id
          minioObjectName
          otherAttachmentName
          uuid
          attachable {
            attachableDiscriminator
            bucketName
            id
            otherAttachmentName
            registrationType
            uuid
          }
          attachmentType {
            active
            fileType
            id
            kind
            name
            uuid
          }
        }
        omcRegistration {
          name
          tin
          uuid
          company {
            active
            tin
            uuid
            tinOrTaxpayerNumber
            name
          }
        }
        terminalRegistration {
          referenceNumber
          terminalName
          uuid
        company {
          active
          tin
          uuid
          tinOrTaxpayerNumber
          name
          }
        }
      }
      status
      message
      fieldsErrors
      extras
    }
  }
`;

export const CHECK_OMC_TERMINAL_SAME_TIN = gql`
  query CheckOmcTerminalSameTin($input: OmcTerminalReqInput!) {
    checkOmcTerminalSameTin(input: $input) {
      code
      data
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const CREATE_OMC_STOCK_REPORT = gql`
  mutation CreateOmcStockReport($input: OmcStockReportReqInput!) {
    createOmcStockReport(input: $input) {
      data {
        active
        createdAt
        reportingDate
        status
        uuid
      }
      extras
      fieldsErrors
      message
      status
      code
    }
  }
`;

export const GET_OMC_STOCK_REPORT_BY_OMC = gql`
  query GetOmcStockReportsByOmc($omcUuid: UUID!) {
    getOmcStockReportsByOmc(omcUuid: $omcUuid) {
      code
      data {
        active
        reportingDate
        status
        uuid
        createdAt
        stocks {
          active
          capacity
          uuid
          terminal {
            active
            referenceNumber
            status
            terminalName
            uuid
          }
          product {
            active
            minCapacityMt
            productName
            colorCode
            uuid
          }
          productUnitConversion {
            uuid
            unitOfMeasure {
              active
              code
              name
              uuid
            }
          }
        }
        usageList {
          quantity
          uuid
        }
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const GET_OMC_STOCK_REPORT_DETAIL = gql`
  query GetOmcStockReport($uuid: UUID!) {
    getOmcStockReport(uuid: $uuid) {
      code
      data {
        active
        reportingDate
        status
        uuid
        stocks {
          active
          capacity
          uuid
          terminal {
            active
            referenceNumber
            status
            terminalName
            uuid
          }
          product {
            active
            productName
            colorCode
            uuid
          }
          productUnitConversion {
                    active
                    conversionFactor
                    uuid
                    unitOfMeasure {
                        active
                        code
                        name
                        uuid
                    }
                    product {
                        active
                        colorCode
                        id
                        isBps
                        minCapacityMt
                        productCode
                        productName
                        uuid
                    }
                }
        }
        usageList {
          active
          uuid
          quantity
          product {
            active
            productName
            uuid
          }
          productUsage {
            active
            isTransit
            usageName
            uuid
          }
         productUnitConversion {
                    active
                    conversionFactor
                    uuid
                    unitOfMeasure {
                        active
                        code
                        name
                        uuid
                    }
                    product {
                        active
                        colorCode
                        id
                        isBps
                        minCapacityMt
                        productCode
                        productName
                        uuid
                    }
                }
        }
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SUBMIT_OMC_USAGE_REPORT = gql`
  mutation SubmitOmcUsage($input: OmcProductUsageReqInput!) {
    submitOmcUsage(input: $input) {
      code
      data {
        active
        uuid
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const UPDATE_OMC_STOCK_REPORT = gql`
  mutation UpdateOmcStockReport($input: OmcStockReportUpdateReqInput!) {
    updateOmcStockReport(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        createdAt
        createdBy
        reportingDate
        status
        updatedAt
        updatedBy
        uuid
      }
    }
  }
`;

export const SUBMIT_OMC_STOCK_REPORT = gql`
  mutation SubmitOmcStockReport($omcReportUuid: UUID!) {
    submitOmcStockReport(omcReportUuid: $omcReportUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        createdAt
        createdBy
        reportingDate
        status
        updatedAt
        updatedBy
        uuid
      }
    }
  }
`;

export const UPDATE_OMC_USAGE_REPORT = gql`
  mutation UpdateOmcUsage($input: OmcUsageUpdateReqInput!) {
    updateOmcUsage(input: $input) {
      data {
        active
        createdAt
        createdBy
        reportingDate
        status
        updatedAt
        updatedBy
        uuid
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SAVE_OMC_DEMAND_PROJECTION = gql`
  mutation SaveOmcDemandProjection($input: SaveDemandProjectionInputInput!) {
    saveOmcDemandProjection(input: $input) {
      code
      data {
        active
        companyId
        companyName
        cycleUuid
        omcUuid
        status
        uuid
      }
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const SIGN_OMC_CONTRACT = gql`
  mutation SignOmcContract($input: OmcContractSignReqInput!) {
    signOmcContract(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        attachableDiscriminator
        bucketName
        contractNumber
        endAt
        otherAttachmentName
        registrationStatus
        registrationType
        startAt
        updatedAt
        updatedBy
        uuid
        workflowDefinitionKey
        workflowInstanceId
        workflowStatus
      }
    }
  }
`;

export const SAVE_TRANSIT_CONSIGNEES = gql`
  mutation SaveTransitConsignees($input: SaveTransitConsigneeInputInput!) {
    saveTransitConsignees(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        attachableDiscriminator
        bucketName
        companyId
        companyName
        createdAt
        cycleUuid
        locked
        lockedAt
        nonComplianceReason
        omcUuid
        otherAttachmentName
        registrationType
        reopenedAt
        status
        submittedAt
        uuid
         attachments {
                active
                id
                minioObjectName
                otherAttachmentName
                uuid
                attachable {
                    bucketName
                    id
                    otherAttachmentName
                    registrationType
                    uuid
                }
                attachmentType {
                    active
                    fileSize
                    fileType
                    id
                    kind
                    name
                    uuid
                }
            }
      }
    }
  }
`;

export const SAVE_TRANSIT_STOCK = gql`
  mutation SaveTransitStocks($input: SaveTransitStockInputInput!) {
    saveTransitStocks(input: $input) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        attachableDiscriminator
        bucketName
        companyId
        companyName
        createdAt
        cycleUuid
        nonComplianceReason
        omcUuid
        otherAttachmentName
        registrationType
        reopenedAt
        status
        submittedAt
        uuid
      }
    }
  }
`;

export const GET_OMC_CERTIFICATE_PREVIEW = gql`
  query GetCertificateByOmcUuid($omcUuid: UUID) {
    getCertificateByOmcUuid(omcUuid: $omcUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        createdAt
        expiredAt
        issuedAt
        updatedBy
        uuid
        omcRegistration {
          registrationStatus
          registrationType
          uuid
          registrationDate
          registrationNumber
        }
        attachment {
          active
          id
          minioObjectName
          otherAttachmentName
          uuid
          attachable {
            id
            otherAttachmentName
            registrationType
            uuid
          }
          attachmentType {
            active
            createdAt
            fileType
            id
            kind
            name
            uuid
          }
        }
      }
    }
  }
`;

export const CURRENT_WINDOW_DEMAND_DRAFT = gql`
  query CurrentOmcDemandDraft {
    currentOmcDemandDraft {
      code
      extras
      fieldsErrors
      message
      status
      data {
        active
        cycleUuid
        locked
        uuid
        status
      }
    }
  }
`;

export const DELETE_OMC_DEMAND_DRAFT = gql`
  mutation DeleteOmcDemandDraft($submissionUuid: UUID!) {
    deleteOmcDemandDraft(submissionUuid: $submissionUuid) {
      code
      data
      dataList
      extras
      fieldsErrors
      message
      status
    }
  }
`;

export const GET_PORT_CAPACITY_BALANCE = gql`
  query PortCapacityBalance($cycleUuid: UUID!) {
    portCapacityBalance(cycleUuid: $cycleUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        cycleUuid
        demandMonth
        demandYear
        ports {
          availableBalanceMt
          capacityConfigured
          capacityExceeded
          overCommittedQuantityMt
          portMaxCapacityMt
          portName
          portUuid
          usedQuantityMt
          cargoes {
            cargoIdentifier
            cargoUuid
            deliveryEndDate
            deliveryStartDate
            vesselUuid
            overCommittedQuantityMt
            remainingBalanceMt
            splitEnforcementEnabled
            splitEnforcementMode
            usageDistributions {
              actualPercent
              aggregateOther
              compliant
              configuredPercent
              maximumAllowedQuantityMt
              minimumRequiredQuantityMt
              overLimitQuantityMt
              productUsageName
              productUsageUuid
              remainingAllowedQuantityMt
              shortageQuantityMt
              usedQuantityMt
            }
            usedQuantityMt
          }
        }
      }
    }
  }
`;

export const REQURIRED_GUARANTEE_SUMMARY = gql`
  query RequiredGuaranteeSummary($demandUuid: UUID!) {
    requiredGuaranteeSummary(demandUuid: $demandUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        availableGuaranteeAmount
        coverageEndDate
        coveragePercentageRate
        coverageStartDate
        currencyCode
        currencyName
        demandMonth
        demandYear
        fobCurrencyCode
        fobCurrencyName
        fobMultiplier
        fobValue
        message
        requiredGuaranteeAmount
        includedProjectionMonths
        projectionsIncluded
        shortfallAmount
        sufficient
        totalMetricTons
        includedPreviousActualMonths
        previousActualDemandIncluded
        previousActualMetricTons
      }
    }
  }
`;

export const GET_OVERDUE_PENDING_BILL_SUMMARY = gql`
  query OverduePendingBillsSummary {
    overduePendingBillsSummary {
      data {
        companyId
        currency
        cutoffDateTime
        overdueBillCount
        totalAmount
        bills {
          billDate
          billNumber
          billStatus
          clientName
          clientPhoneNumber
          controlNumber
          currency
          description
          id
          totalAmountAfterTax
          uuid
          itemList {
            collectionCenter
            collectionCenterId
            description
            gfsCode
            id
            isExempted
            quantity
            taxAmount
            totalAmount
            unitPrice
            billItemDetails {
              details
              id
              quantification
              taxAmount
              totalAmount
              unitPrice
            }
          }
        }
      }
      extras
      fieldsErrors
      message
      status
      code
    }
  }
`;

export const GET_LOGGED_IN_OMC_LAST_MONTHS_PROJECTS = gql`
  mutation GetLoggedInOmcLastMonthDemandProjection {
    getLoggedInOmcLastMonthDemandProjection {
      code
      extras
      fieldsErrors
      message
      status
      data {
        companyId
        companyName
        sourceCycleUuid
        sourceDemandMonth
        sourceDemandPeriodLabel
        sourceDemandUuid
        sourceDemandYear
        projections {
          portName
          portUuid
          months {
            month
            periodLabel
            productName
            productUuid
            totalQty
            year
            sourcingEntries {
              computedPercent
              quantity
              usageName
              usageUuid
            }
          }
        }
      }
    }
  }
`;

export const REQUIRED_OMC_PRODUCT_MARKET_SHARE_SUMMARY = gql`
query RequiredOmcProductMarketShareSummary($demandUuid: UUID!) {
    requiredOmcProductMarketShareSummary(
        demandUuid: $demandUuid
    ) {
        code
        extras
        fieldsErrors
        message
        status
        data {
            companyName
            demandMonth
            demandMonthDays
            demandYear
            hasWarning
            totalRequiredMarketShareQuantityMt
            totalShortageQuantityMt
            totalSubmittedQuantityMt
            warningMessage
            products {
                belowRequiredMarketShare
                expectedMonthlyProductMt
                omcProductMarketSharePercentage
                productName
                requiredMarketShareQuantityMt
                shortageQuantityMt
                submittedQuantityMt
                warningMessage
            }
        }
    }
}`;

export const DELETE_TRANSIT_STOCK = gql`
mutation DeleteTransitStockInTank($stockUuid: UUID!) {
    deleteTransitStockInTank(stockUuid: $stockUuid) {
        code
        extras
        fieldsErrors
        message
        status
        data {
            active
            status
            uuid
        }
    }
}`;

export const GET_PUBLIC_ATTACHMENTS = gql`
  query PublicAttachments($pageableParam: PageableParamInput) {
    publicAttachments(pageableParam: $pageableParam) {
      number
      size
      totalElements
      content {
        uuid
        description
        status
        attachmentType
        active
        publicAttachmentName
        createdAt
        updatedAt
        attachments {
          uuid
          otherAttachmentName
          attachmentType {
            name
            fileType
          }
        }
      }
    }
  }
`;

export const DELETE_TRANSIT_CONSIGNEE = gql`
mutation DeleteTransitConsignee($transitConsigneeUuid: UUID!) {
    deleteTransitConsignee(transitConsigneeUuid: $transitConsigneeUuid) {
        code
        extras
        fieldsErrors
        message
        status
        data {
            active
            status
            uuid
        }
    }
}`;

export const DELETE_OMC_DEMAND_CARGO_PRODUCT = gql`
mutation DeleteOmcDemandCargoProduct(
    $vesselUuid: UUID
    $productUuid: UUID
    $portUuid: UUID
    $submissionUuid: UUID
) {
    deleteOmcDemandCargoProduct(
        vesselUuid: $vesselUuid
        productUuid: $productUuid
        portUuid: $portUuid
        submissionUuid: $submissionUuid
    ) {
        code
        extras
        fieldsErrors
        message
        status
        data {
            active
            uuid
        }
    }
}`;

export const DELETE_OMC_DEMAND_PRODUCT_USAGE = gql`
mutation DeleteOmcDemandProductUsage(
    $vesselUuid: UUID
    $productUuid: UUID
    $portUuid: UUID
    $usageUuid: UUID
    $submissionUuid: UUID
    $terminalUuid: UUID
) {
    deleteOmcDemandProductUsage(
        vesselUuid: $vesselUuid
        productUuid: $productUuid
        portUuid: $portUuid
        usageUuid: $usageUuid
        submissionUuid: $submissionUuid
        terminalUuid: $terminalUuid
    ) {
        code
        extras
        fieldsErrors
        message
        status
        data {
            active
            uuid
        }
    }
}`;

export const GET_CURRENT_PUBLISHED_TENDER_CALENDAR = gql`
query CurrentPublishedTenderCalendar($planningYear: Int!) {
    currentPublishedTenderCalendar(planningYear: $planningYear) {
        code
        data {
            active
            approvedAt
            automaticallyGenerated
            calendarCode
            coverageEndDate
            coverageGapJustification
            coverageStartDate
            currentPublishedVersion
            publishedAt
            status
            title
            uuid
            cycles {
                active
                createdAt
                cycleCode
                tenderDocumentPreparationStart
                tenderDocumentPreparationEnd
                tenderClosingOpeningAt
                tenderMonth
                tenderYear
                requirementWindowEnd
                requirementWindowStart
                omcEnquiryStart
                omcEnquiryEnd
                invitationToBidAt
                sequenceNumber
            }
        }
        extras
        fieldsErrors
        message
        status
    }
}`;

